import { NX5_RegistrationDetails_API } from "../../adapters/NX5/NX5_RegistrationDetailsAdapter";

export const get_NX5_RegistrationDetails = () => {
  return new Promise((resolve, reject) => {
    NX5_RegistrationDetails_API()
      .then((res) => {
        if (res?.status === 200 && res?.data) {
          resolve(res.data);
        } else {
          // if data is missing, reject with proper error
          const errorMsg =
            res?.data?.error?.message || "No data received from API";
          reject(errorMsg);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};
